import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import TimelineUI from './TimelineUI';
import { getFieldMapping } from './service/utils';
const Timeline = ({ fields }) => {
    const { decades } = getFieldMapping({ fields });
    return _jsx(TimelineUI, { decades: decades });
};
export default Timeline;
